import styled from "styled-components";
import { Nav, NavItem, Form, FormGroup } from "react-bootstrap";

export const Wrapper = styled.div`
    .ag-theme-alpine-dark {
        font-family: Roboto !important;
    }
`;

export const RemoteTableWrapper = styled.table`
    margin-bottom: 0px;
    
    & > thead > tr {
        background-color: #ddd;
    }

    & > thead > tr > th:nth-child(1) {
        border-left: 1px solid #ddd;
    }

    & > thead > tr > th:last-child {
        border-right: 1px solid #ddd;
    }

    & > thead > tr > th {
        text-align: center;
        border: 1px solid white;
        padding-top: 3px;
        padding-bottom: 3px;
    }

    & > tbody > tr > td {
        text-align: center;
        vertical-align: middle;
        padding-top: 3px;
        padding-bottom: 3px;
    }

    & > thead > tr > th {
        position: sticky;
        top: -1px;
        background-color: rgb(221, 221, 221) !important;
    }

    & > thead > tr:nth-child(2) > th {
        position: sticky;
        top: 25px;
        background-color: #dfe7f1 !important;
    }
`;


export const RemoteGridWrapper = styled.div`
    height: 76vh;
    width: 100%;

    @media (max-height: 1080px) {
        height: 73vh;
    }

    .ag-header-cell {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        background-color: rgb(221, 221, 221);
        color: #000000;
        font-size: 12px;
        font-weight: bold;
    }

    .ag-header-cell > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        font-size: 12px;
        /* padding-bottom: 5px; */
    }

    .ag-header-cell > .ag-react-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .ag-header-cell > .ag-react-container > div {
        text-align: center;
        /* padding-bottom: 5px; */
    }

    .ag-cell {
        text-align: center;
        line-height: 30px;
        font-size: 12px;
    }

   .ag-row {
        z-index: 0;
    }

     .ag-row.ag-row-hover {
     background-color: #eaf2fa;
     }

    .donor-user-case-load {
        line-height: initial;
        display: flex;
        align-items: center;
    }

    .donor-user-case-load > .ag-react-container {
        width: 100%;
    }

    .donor-drop-down {
        display: flex;
        align-items: center;
    }

    .donor-drop-down > .ag-react-container {
        width: 100%;
    }

    .ag-body-viewport {
        border-left: 1px solid rgb(204, 204, 204);
        border-right: 1px solid rgb(204, 204, 204);
        border-bottom: 1px solid rgb(204, 204, 204);
    }

    .ag-icon {
        color: white;
    }

    .customSortUpLabel,
    .customSortDownLabel {
        margin-left: 3px;
    }
`;

export const GridWrapper = styled.div`
    height: 68vh;
    width: 100%;

    @media (max-height: 1080px) {
        height: 62vh;
    }

    @media (max-device-width: 1877px) {
        .ag-header-cell {
            font-size: 12px;
        }

        .ag-header-cell > .ag-cell-label-container > .ag-header-cell-label {
            font-size: 12px;
        }

        .ag-header-cell-text {
            font-size: 12px;
        }

        .ag-cell {
            font-size: 12px;
        }
    }

    .ag-header-cell {
        display: flex;
        justify-content: center;
        align-items: center;
        // padding-bottom: 5px;
    }

    .ag-header-cell > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        font-size: 14px;
    }

    .ag-header-cell > .ag-react-container {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        height: 85%;
    }

    .ag-header-cell > .ag-react-container > div {
        text-align: center;
    }

    .ag-cell {
        text-align: center;
        line-height: 30px;
    }

    // .donor-connect-user-case-load {
    //     line-height: initial;
    //     display: flex;
    //     align-items: center;
    // }

    // .donor-connect-user-case-load > .ag-react-container {
    //     width: 100%;
    // }

    // .donor-connect-drop-down {
    //     display: flex;
    //     align-items: center;
    // }

    // .donor-connect-drop-down > .ag-react-container {
    //     width: 100%;
    // }

    .action-menu {
        overflow: visible;
        border-bottom: none;
        line-height: 28px;
        // display: flex;
        // align-items: center;
    }

    .action-menu.ag-cell-focus {
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-header-row {
        background-color: lightgray;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

   .remote-list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 26px;
        border-color: #ccc;
        // font-size: 12px;
    }

    .remote-list-other-cell {
        background-color: #DBDBDB;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 33px;
        border-color: #B7B7B7;
    }

    .remote-list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
    }

    .remote-list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    span.targeted > .dropdown {
        padding: 0px;
    }

    span.targeted > .dropdown > .dropdown-toggle {
        background-color: transparent;
        color: green;
        font-weight: 700;
        font-size: 16px;
        padding: 0px 10px 0px 10px;
        border: 0 none;
    }

    span.active-targeted > .dropdown > .dropdown-toggle {
        background-color: transparent;
        color: yellow;
        font-weight: 700;
        font-size: 16px;
        padding: 0px 10px 0px 10px;
        border: 0 none;
    }

    span.category > .dropdown > .dropdown-toggle {
        background-color: transparent;
        // color: green;
        font-weight: 700;
        font-size: 16px;
        padding: 0px 10px 0px 10px;
        border: 0 none;
    }

    // .dropdown > .dropdown-toggle {
    //     font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    // }

    // .dropdown-menu {
    //     font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    // }

    .dropdown-menu > li > a:hover, .dropdown-menu > li > a:focus {
        background-color: #ddd;
    }

  .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-hover {
         background-color: #d7e6f4;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

`;

export const TableWrapper = styled.div`
    .table {
        border: 1px solid #eee;
        border-radius: 4px;
    }

    .table > thead > tr {
        background-color: #222628;
        color: #fff;
    }

    .table > thead > tr > th {
        text-align: center;
        border: 1px solid #fff;   
    }

    .table > tbody > tr > td {
        text-align: center;
        vertical-align: middle;
    }

    .table > tbody {
        // border: 1px solid pink;
        height: 400px;
    }

    // .table-striped>tbody>tr:nth-of-type(even) {
    //     background-color: darkgrey !important;
    //     color: #fff;
    // }

    // .table-striped>tbody>tr:nth-of-type(odd) {
    //     background-color: #181d1f !important;
    //     color: #fff;
    // }
`;

interface INavWrapperProps {
    verticalAlign?: string,
    minTabWidth?: string,
    tabHeight?: string
}

export const NavWrapper = styled(Nav).withConfig({
    shouldForwardProp: (prop: string) => !['verticalAlign', 'minTabWidth', 'tabHeight'].includes(prop)
}) <INavWrapperProps>`
    & > li {
        height: ${(p: INavWrapperProps) => p.tabHeight ? p.tabHeight : '42px'};
    }

    & > li > a {
        font-size: 14px;
        font-weight: 500;
        background-color: #ddd;
        color: #a1a1a1;
        // width: 160px;
        text-align: center;
        // line-height: 15px;
        padding: 5px 15px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: ${(p: INavWrapperProps) => p.verticalAlign ? p.verticalAlign : 'flex-end'};
        //min-width: ${(p: INavWrapperProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '0px'};
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    & > li.active > a {
        // font-size: 14px;
        // line-height: 15px;
        // padding: 5px 7.5px;
    }

    @media (width < 1920px) {
        & > li > a,
        & > li.active > a {
            // font-size: 12px;
            // min-width: ${(p: INavWrapperProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '120px'};
        }
    }
`;

export const ViewWrapper = styled.div`
    .modal-container {
        position: relative;
    }

    .modal-container .modal, .modal-container .modal-backdrop {
        position: absolute;
    }
`;

export const FormGroupWrapper = styled(FormGroup)`
    margin-bottom: 5px;
    // display: flex;
    // align-items: center;

    // & > .col-lg-3 {
    //     padding-left: 0px;
    // }
`;

interface INavItemProps {
    tabWidth?: string
}

export const NavItemWrapper = styled(NavItem) <INavItemProps>`
    // & > a {
    //     width: ${(p: INavItemProps) => p.tabWidth ? p.tabWidth + 'px !important' : '150px'};
    // }

    // & > a {
    //     min-width: 140px;
    // }
`;

export const FormWrapper = styled(Form)`
    margin-bottom: 20px;

    .row-underlined {
        border-bottom: .5px solid #cccccc; /* Change the color as needed */
        padding-bottom: 5px; /* Adjust as needed to control the space between text and underline */
        margin-bottom: 10px; /* Adjust as needed to control the space below the underline */
    }

    .form-group-spacing {
        margin-bottom: 10px;
    }

    & > .form-group {
        min-height: 70px;
    }

    & > .form-group:nth-child(odd) {
        background-color: #f9f9f9;
    }

    .row {
        margin-bottom: 5px;
    }

    .row-value-center > .col-sm-3:nth-child(2),
    .row-value-center > .col-sm-3:nth-child(4) {
        text-align: center;
    }
`;

export const DiagnosticsFormWrapper = styled(FormWrapper)`
    .form-group {
        margin-bottom: 5px
    }

    .form-control-static {
        background-color: #eee;
        border: 1px solid #ccc;
        padding: 6px 12px;
        border-radius: 4px;
    }
`;

export const cardStyle: React.CSSProperties = {
    border: '1px solid #ddd',
    borderRadius: 8,
    backgroundColor: '#fff',
    marginBottom: 16,
    overflow: 'hidden'
};

export const cardHeaderStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    padding: '7px 14px',
    borderBottom: '1px solid #e8e8e8',
    backgroundColor: '#fff',
    flexWrap: 'wrap',
    gap: 4
};

export const cardTitleRowStyle: React.CSSProperties = { display: 'flex', alignItems: 'center', gap: 10 };

export const cardNumStyle: React.CSSProperties = {
    width: 28,
    height: 28,
    borderRadius: '50%',
    backgroundColor: '#1a3a52',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    fontSize: 14
};

export const cardTitleTextStyle: React.CSSProperties = {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 700,
    color: '#1a3a52',
    fontSize: 14,
    letterSpacing: '0.04em',
    textTransform: 'uppercase'
};

export const cardBodyStyle: React.CSSProperties = { padding: '16px 16px 8px', backgroundColor: '#fff' };

export const cardBodyTitleStyle: React.CSSProperties = { padding: '0px 0px 16px 0px', backgroundColor: '#fff' };

export const cardBodyTitleTextStyle: React.CSSProperties = {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 700,
    color: '#1a3a52',
    fontSize: 16,
    letterSpacing: '0.04em',
    textTransform: 'uppercase'
};

export const cardFooterStyle: React.CSSProperties = {
    padding: '12px 16px',
    backgroundColor: '#fff',
    borderTop: '1px solid #e8e8e8',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 8
};

export const sectionHelperStyle: React.CSSProperties = {
    fontFamily: 'Roboto, sans-serif',
    fontSize: 13,
    color: '#757575',
    marginBottom: 16
};

export const fieldLabelStyle: React.CSSProperties = {
    fontFamily: 'Roboto, sans-serif',
    textTransform: 'uppercase',
    fontWeight: 700,
    color: '#444',
    fontSize: 12,
    letterSpacing: '0.03em'
};

export const fieldSurfaceStyle: React.CSSProperties = {
    fontFamily: 'Roboto, sans-serif',
    backgroundColor: '#fff'
};
export const inlineFieldRowStyle: React.CSSProperties = { display: 'flex', alignItems: 'center', gap: 12 };
export const inlineFieldLabelStyle: React.CSSProperties = { ...fieldLabelStyle, marginBottom: 0, minWidth: 150 };
export const inlineFieldInputWrapStyle: React.CSSProperties = { flex: 1 };
export const pendingChangesStyle: React.CSSProperties = { color: '#8a6d3b', fontSize: 12, fontWeight: 600, marginLeft: 'auto' };
export const primaryBtnStyle: React.CSSProperties = {};

export const bannerStyle: React.CSSProperties = {
    padding: '10px 12px',
    marginBottom: 14,
    backgroundColor: '#e8f4fc',
    borderLeft: '4px solid #1a6fc4',
    fontSize: 13,
    color: '#1a3a52'
};

export const dangerBannerStyle: React.CSSProperties = {
    padding: '10px 12px',
    marginBottom: 14,
    backgroundColor: '#fdecea',
    borderLeft: '4px solid #d9534f',
    fontSize: 13,
    color: '#a94442'
};